import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles, Link } from '@material-ui/core';
import { ERROR_MESSAGES } from '../../constants';

export default function SystemError() {
  const history = useHistory();
  const { location: { message = ERROR_MESSAGES.contactAdmin } } = history;

  const useStyles = makeStyles({
    container: {
      textAlign: 'center',
      marginTop: 40,
      fontSize: 20,
    },
    message: {
      paddingBottom: 20,
    },
  });

  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.message}>{message}</div>
      <Link href="/">Back to Home</Link>
    </div>
  );
}
